export enum DocumentRequestStatus {
  NOT_PROCESSED = 'NOT_PROCESSED',
  PROCESSED = 'PROCESSED',
  CLOSED = 'CLOSED',
}

export enum DocumentSignatureStatus {
  TO_SIGN = 'TO_SIGN',
  NOT_TO_SIGN = 'NOT_TO_SIGN',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_FOR_SIGNATURE = 'WAITING_FOR_SIGNATURE',
  FULL = 'FULL',
}
